import React, { useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import classes from "./SelectGallery.module.css";
import TextArea from "../../Component/TextArea";
import { RxCross2 } from "react-icons/rx";
import { Input } from "../../Component/Input/Input";
import { Button } from "../../Component/Button/Button";
import { useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import { AiFillCheckCircle } from "react-icons/ai";
const SelectGallery = ({
  show,
  setShow,
  setIsFile,
  setGalleryId,
  setVideFile,
  galleryId,
  setFromGallery,
}) => {
  const [active, setactive] = useState("original");
  const [text, setText] = useState(
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries,"
  );
  const { allVideos } = useSelector((state) => state?.commonReducer);
  const [selected, setSelected] = useState(galleryId);

  return (
    <div>
      <ModalSkeleton
        setShow={setShow}
        show={show}
        width={"1000px"}
        //   header={"Login"}
        modalClass={classes.main}
        borderRadius={"20px"}

        //   showCloseIcon
      >
        <div>
          <div className={classes.header}>
            <div
              className={[
                classes.btn,
                active === "original" && classes.active,
              ].join(" ")}
              onClick={() => {
                setactive("original");
              }}
            >
              <h3>Select From Gallery</h3>
            </div>
          </div>
          <Container className={classes.content}>
            <Row className={classes.gap}>
              {allVideos?.map((item) => {
                return (
                  <Col
                    className={classes.videoCol}
                    md={6}
                    sm={12}
                    onClick={() => {
                      setGalleryId(item?._id);
                      setSelected(item?._id);
                      fetch(item?.video)
                        .then((response) => response.blob())
                        .then((blob) => {
                          setVideFile(blob);
                        });
                      setIsFile(item?.video);
                      setFromGallery(false);
                    }}
                  >
                    <div className={classes.videoWrap}>
                      <video
                        // style={{ width: "100%" }}
                        className={classes.video}
                        autoplay
                        src={item?.video}
                        width="100%"
                        height="100%"
                        controls
                      />
                    </div>
                    {selected === item?._id && (
                      <div className={classes.select}>
                        <AiFillCheckCircle size={30} color={"white"} />
                      </div>
                    )}
                  </Col>
                );
              })}
            </Row>
            <Row>
              <Col className="text-center mt-5">
                <Button
                  green
                  label={selected ? "Select" : "Close"}
                  onClick={() => setShow(false)}
                />
              </Col>
            </Row>
          </Container>

          {/* <div
            className={classes.crossBtn}
            onClick={() => {
              setShow(false);
            }}
          >
            <RxCross2 size={20} color={"var(--white-color"} />
          </div> */}
        </div>
      </ModalSkeleton>
    </div>
  );
};

export default SelectGallery;
